// extracted by mini-css-extract-plugin
export default {"strikethrough":"_hiZd1","fitToText":"RFsIJI","flexGrow":"qf4of5","optionItemText":"DC5h2Q"};